import React from 'react';
import { css } from '@emotion/css';
import { BaseLoginButton } from '../../ui/base-login-button/base-login-button';
import GoogleIcon from '../../../../assets/icons/googleColored.svg';
import { useSocialLogin } from '../../hooks/auth-api.hooks';

const googleButtonStyle = css({
  backgroundColor: 'var(--primary-color)',
  color: 'var(--pc-700)',
  border: '1px solid rgba(var(--pcrgba-200), 0.5)',
  boxShadow: '0 4px 12px rgba(var(--pcrgba-200), 0.1)',
  ':hover:not(:disabled)': {
    backgroundColor: 'var(--pc-100)',
    boxShadow: '0 6px 15px rgba(var(--pcrgba-300), 0.15)',
    borderColor: 'var(--pc-300)',
  },
});

const contentWrapper = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  padding: '0 0 0 24px',
});

const iconStyle = css({
  width: '20px',
  height: '20px',
  objectFit: 'contain',
  position: 'absolute',
  left: 0,
});

const textStyle = css({
  flex: 1,
  textAlign: 'center',
});

export interface GoogleButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'onClick'> {
  onSuccess?: (user: any) => void;
  redirectUrl?: string;
}

export const GoogleButton: React.FC<GoogleButtonProps> = ({ className, onSuccess, redirectUrl, ...rest }) => {
  const { mutate: socialLogin, isPending } = useSocialLogin();

  const handleGoogleLogin = () => {
    console.log('[GoogleButton] Starting Google login...');
    socialLogin(
      { provider: 'google', redirectUrl },
      {
        onSuccess: (response) => {
          console.log('[GoogleButton] Login response received:', response);
          
          // Validate that we have the authorization URL
          if (!response?.authorizationUrl) {
            console.error('[GoogleButton] ERROR: No authorizationUrl in response', response);
            return;
          }

          // Store the redirect URL in sessionStorage so the callback handler can retrieve it
          if (redirectUrl) {
            console.log('[GoogleButton] Storing redirect URL:', redirectUrl);
            sessionStorage.setItem('social_login_redirect_url', redirectUrl);
          }
          
          console.log('[GoogleButton] Redirecting to Google authorization URL...');
          window.location.href = response.authorizationUrl;
        },
        onError: (error: any) => {
          console.error('[GoogleButton] Login error:', {
            message: error?.message,
            status: error?.response?.status,
            data: error?.response?.data,
            error,
          });
        },
      }
    );
  };

  return (
    <BaseLoginButton 
      className={`${googleButtonStyle} ${className || ''}`} 
      onClick={handleGoogleLogin}
      disabled={isPending}
      {...rest}
    >
      <div className={contentWrapper}>
        <img src={GoogleIcon} alt="Google" className={iconStyle} />
        <span className={textStyle}>Continue com Google</span>
      </div>
    </BaseLoginButton>
  );
};
